import { Button } from "component/ui/Button";
import { GenericBtn } from "./FinanceRequest";
import { X } from "lucide-react";

const FinanceTopNav = ({ navigate, paymentMethod, isValid, handleSaveAsDraft, onSubmit, isLoading, hasHover }) => {
    return (
        <nav className="flex items-center justify-between w-[96%]  py-3 my-0 md:w-full px-2 md:!px-8 myborder-slixe mx-auto">
            <div
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-1 pl-0 cursor-pointer md:gap-3 md:pl-4"
            >
                <X size={14} className="rotate-90 cursor-pointer" />

                <h6 className="m-0 text-gray-90 text-base md:text-base font-[450]">
                    Request finance
                </h6>
            </div>

            {paymentMethod && (
                <div className="flex items-center gap-4 pr-0 md:pr-4">
                    <Button
                        disabled={isLoading}
                        variant="ghost"
                        text={"Continue"}
                        onClick={handleSaveAsDraft}
                    >
                        Save as draft
                    </Button>

                    <GenericBtn
                        text={isLoading ? "Loading..." : "Send request"}
                        disabled={!paymentMethod ? true : !isValid || isLoading}
                        onClick={onSubmit}
                        hasHover={hasHover}
                    />
                </div>
            )}
        </nav>
    );
};

export default FinanceTopNav